module.exports = __webpack_public_path__ + "img/b_1.3d1d1618.png";